export default class StrapiResponse<T> {
    entries: Array<T>;
    entriesCount: number;
    page: number;
    pageCount: number;

    constructor(entries: Array<T>,
        entriesCount: number,
        page: number,
        pageCount: number
    ) {
        this.entries = entries;
        this.entriesCount = entriesCount;
        this.page = page;
        this.pageCount = pageCount
    }
}